import React from 'react'
import AwesomeSlider from 'react-awesome-slider'
import 'react-awesome-slider/dist/styles.css'
import 'react-awesome-slider/dist/custom-animations/fold-out-animation.css'
import { StyledCarousel } from './Carousel.styled'
import TextPage from '../TextPage'
const Carousel = ({ component, intlKey, pagingInfo }) => {
  const [isEdge, setEdge] = React.useState(window.navigator.userAgent.indexOf('Edge') > -1)
  const slides = component.slides
    .map((slide, index) => (
      <div
        key={`${component.type}-${index}`}
        className='carouselSlide'
      >
        {slide.type === 'text' && <TextPage {...slide} intlKey={intlKey} />}
      </div>
    ))
  return (
    <StyledCarousel isEdge={isEdge}>
      <AwesomeSlider animation='foldOutAnimation' infinite={false} organicArrows={!isEdge}>
        {slides}
      </AwesomeSlider>
    </StyledCarousel>
  )
}

export default Carousel
